export const SET_VWODS = '[VWODS] SET_VWODS';
